import { create } from "zustand";
import TokenResponse from "../interfaces/tokenResponse";

interface UserStore {
    token: string;
    username: string;
    isAdmin: boolean;
    triedLogin: boolean;
    destinyRoute: string;

    setToken: (loggedIn: TokenResponse) => void;
    setTriedLogin: (triedLogin: boolean) => void;
    setDestinyRoute: (destinyRoute: string) => void;
}

const useUserStore = create<UserStore>((set) => ({
    token: "",
    username: "",
    isAdmin: false,
    triedLogin: false,
    destinyRoute: "/",

    setToken: (token: TokenResponse) => set({ token: token.token, username: token.username, isAdmin: token.isAdmin }),
    setTriedLogin: (triedLogin: boolean) => set({ triedLogin }),
    setDestinyRoute: (destinyRoute: string) => set({ destinyRoute }),
}));

export default useUserStore;